// extracted by mini-css-extract-plugin
export default {"background":"ArtistBackground_background__heR34","image":"ArtistBackground_image__3jF2j"};